import React from "react";
import {
  BarChart3,
  FileSearch,
  Briefcase,
  Shield,
  ArrowRight,
  Headset,
} from "lucide-react";
import "./index.css"; // Import custom CSS


export const ReadyToStart = () => {
  return(
    <section className="cta-section animate">
        <div className="cta-content">
          <h2>Ready to Start Trading?</h2>
          <p>
            Join thousands of successful traders in the Pakistan Stock Market
          </p>
          <div className="cta-buttons">
            <a href="/create-account" className="cta-button">
              Open Account
              <ArrowRight size={20} />
            </a>

            <a href="tel:+923335299115" className="support-info">
              <p>
                <Headset size={12} /> Need Help?
              </p>
              <p>+92 333 529 9115</p>
            </a>
          </div>
        </div>
      </section>
  )
}

export default function OurServices() {
  return (
    <>
      <div className="pro-ser-container">
        {/* Main Heading */}
        <div className="pro-ser-heading">
          <h1 className="pro-ser-title">Our Services</h1>
          <p className="pro-ser-description">
            The Company aims at exceeding the expectations of every client by
            providing outstanding customer service, reliable, and timely
            information while maintaining the competitive edge of being more
            professional and customer-oriented.
          </p>
        </div>

        {/* Services Grid */}
        <div className="pro-ser-grid">
          {/* Brokerage Services */}
          <div className="pro-ser-card">
            <div className="pro-ser-card-icon">
              <BarChart3 className="pro-ser-icon" />
              <h2 className="pro-ser-card-title">Brokerage Services</h2>
            </div>
            <p className="pro-ser-card-text">
              We offer comprehensive brokerage services for retail,
              institutional, and international investors. Our platform provides
              seamless trading experiences with competitive commission rates and
              real-time market access to Pakistan's Stock Markets.
            </p>
          </div>

          {/* Research Department */}
          <div className="pro-ser-card">
            <div className="pro-ser-card-icon">
              <FileSearch className="pro-ser-icon" />
              <h2 className="pro-ser-card-title">Research Department</h2>
            </div>
            <p className="pro-ser-card-text">
              Our dedicated research team provides in-depth market analysis,
              company reports, and investment recommendations. Stay ahead with
              our daily market updates, economic forecasts, and sector-specific
              research to make informed investment decisions.
            </p>
          </div>

          {/* Portfolio & Its Access */}
          <div className="pro-ser-card">
            <div className="pro-ser-card-icon">
              <Briefcase className="pro-ser-icon" />
              <h2 className="pro-ser-card-title">Portfolio & Its Access</h2>
            </div>
            <p className="pro-ser-card-text">
              Manage your investment portfolio with our advanced tools and
              platforms. Access your portfolio anytime, anywhere through our
              secure web portal and mobile application. Track performance, view
              transaction history, and receive personalized investment insights.
            </p>
          </div>

          {/* Information Privacy Policy */}
          <div className="pro-ser-card">
            <div className="pro-ser-card-icon">
              <Shield className="pro-ser-icon" />
              <h2 className="pro-ser-card-title">Information Privacy Policy</h2>
            </div>
            <p className="pro-ser-card-text">
              We are committed to protecting your personal and financial
              information. Our robust security measures and strict privacy
              policies ensure that your data remains confidential and secure. We
              adhere to all regulatory requirements and industry best practices.
            </p>
          </div>
        </div>
      </div>
      <ReadyToStart />
    </>
  );
}
